<template>
  <el-main class="el-mainContent">
    <p class="el-divider-header smallHeader">{{$t('base_setting')}}</p>
    <el-form label-position="top" size="mini">
      <el-form-item :label="$t('multiuserlogin')"   class="padding0Label">
        <el-switch v-model="detail.multiuserlogin"  active-value="true" inactive-value="false"></el-switch>
      </el-form-item>
        <el-form-item :label="$t('haveImg')" class="padding0Label">
          <div :class="haveImg">
            <img
              style="display:block;"
              id="_iconImg" 
              alt
              :src="detail.loginbackground"
              class="adminLogoImg"
              v-if="detail.loginbackground!=''"
            />
          </div>
          <div style="display: inline-block">
            <div style="color: red">(建议大小:1376*786)</div>
            <div>
              <el-button class="obpm-btn-default mr-1" plain @click="uploadBgImg('bgcImg')">{{$t('uploadBgImg')}}</el-button>
              <el-button type="danger" plain @click="cleanBgImg">{{$t('cleanBgImg')}}</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('loginLogo')" class="padding0Label">
          <div :class="haveImg">
            <img
              style="display:block;"
              id="_iconImg" 
              alt
              :src="detail.loginLogo"
              class="adminLogoImg"
              v-if="detail.loginLogo!=''"
            />
          </div>

          <div style="display: inline-block">
            <div>
              <el-button class="obpm-btn-default mr-1" plain @click="uploadBgImg('logoImg')">{{$t('uploadBgImg')}}</el-button>
              <el-button type="danger" plain @click="cleanBgImg">{{$t('cleanBgImg')}}</el-button>
            </div>
          </div>
        
        </el-form-item>
        <el-row>
        <el-col :span="6" >
          <el-form-item :label="$t('loginTitle')" prop="loginno"  class="padding0Label">
            <el-input type="text" v-model="detail.loginTitle"></el-input>
        </el-form-item>
        </el-col>
        </el-row>
        <el-row>
        <el-col :span="6" >
        <el-form-item :label="$t('isRegister')"   class="padding0Label">
          <el-switch v-model="detail.isRegister"  active-value="1" inactive-value="0"></el-switch>
        </el-form-item>
        </el-col>
        <el-col  :span="6"  :offset="6">
        <el-form-item :label="$t('isSupervise')"   class="padding0Label">
          <el-switch v-model="detail.isSupervise"  active-value="1" inactive-value="0"></el-switch>
        </el-form-item>
        </el-col>
        </el-row>
        <el-row>
        <el-col  :span="6" >
        <el-form-item :label="$t('registerTitle')" prop="loginno"  class="padding0Label">
            <el-input type="text" v-model="detail.registerTitle"></el-input>
        </el-form-item>
        </el-col>
        <el-col  :span="6"  :offset="6">
        <el-form-item :label="$t('registerUrl')" prop="loginno"  class="padding0Label">
            <el-input type="text" v-model="detail.registerUrl"></el-input>
        </el-form-item>
        </el-col>
        </el-row>

    </el-form>
    <el-form>

      <el-form-item :label="$t('authType')">
        <el-radio-group v-model="detail.authType" @change="changeAuth">
          <el-radio  label="default">{{$t('interface')}}</el-radio>
          <el-radio  label="sso">{{$t('sso')}}</el-radio>
          <el-radio  label="ssl_pkcs12">{{$t('ssl_pkcs12')}}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-form v-if="detail.authType=='default'" label-position="top" size="mini">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('smsAuthenticate')"   class="padding0Label">
            <!-- <el-checkbox v-model="detail.smsAuthenticate" >打开</el-checkbox> -->
            <el-switch v-model="detail.smsAuthenticate"  active-value="true" inactive-value="false"></el-switch>
          </el-form-item>
        </el-col>
      
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-row>
            <el-form-item :label="$t('smsAffectMode')" >
              <el-radio-group v-model="detail.smsAffectMode" :disabled="detail.smsAuthenticate=='true'? false: true">
                <el-radio  label="all">{{$t('all')}}ip</el-radio>
                <el-radio  label="match">{{$t('match')}}</el-radio>
                <el-radio  label="exclude">{{$t('exclude')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('ip_range')"   class="padding0Label" >
              <el-input type="text" class="ip-range" v-model="detail.smsStartRangeIp" :disabled="detail.smsAuthenticate=='true' && (detail.smsAffectMode=='match'|| detail.smsAffectMode=='exclude')? false: true"></el-input>
              <el-input type="text" class="ip-range" v-model="detail.smsEndRangeIp"  :disabled="detail.smsAuthenticate=='true' && (detail.smsAffectMode=='match'|| detail.smsAffectMode=='exclude')? false: true"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
         
        <el-col :span="6" :offset="6">
          <el-row>
            <el-form-item :label="$t('smsTimeout')"   class="padding0Label">
              <el-input type="text" v-model="detail.smsTimeout"  :disabled="detail.smsAuthenticate=='true'? false: true"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('smsContent')"   class="padding0Label">
              <el-input type="textarea" v-model="detail.smsContent"  :disabled="detail.smsAuthenticate=='true'? false: true"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <el-form v-if="detail.authType=='sso'" label-position="top"  size="small">
      <el-row>
        <el-col :span="6">
          <el-row>
            <el-form-item :label="$t('checkldap')"  class="padding0Label">
              <el-select v-model="checkldap" :placeholder="$t('placeholder_select')" @change="changeAuth">
                <el-option
                  v-for="item in ssoAuthOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div v-if="detail.ssoAuth=='cn.myapps.security.sso.CasUserSSO'" class="tip-text">(注意:修改CAS服务器信息需要重启服务器后才生效)</div>

            </el-form-item>
          </el-row>
          <!-- cookie -->
          <el-row v-if="detail.ssoAuth=='cn.myapps.security.sso.CookieUserSSO'">  
            <el-form-item :label="$t('ssoRedirect')"   class="padding0Label">
              <el-input type="text" v-model="detail.ssoRedirect"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ssoLogoutRedirect')"  class="padding0Label">
              <el-input type="text" v-model="detail.ssoLogoutRedirect" ></el-input>
            </el-form-item>
          </el-row>
          <!-- cas -->
          <el-row v-if="detail.ssoAuth=='cn.myapps.security.sso.CasUserSSO'">
            <el-form-item :label="$t('ssoRedirect')"  class="padding0Label">
              <el-input type="text" v-model="detail.ssoRedirect"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ssoLogoutRedirect')"  class="padding0Label">
              <el-input type="text" v-model="detail.ssoLogoutRedirect" ></el-input>
            </el-form-item>
          </el-row>
          <!-- AD/LDAP -->
          <el-row v-if="detail.ssoAuth=='cn.myapps.security.sso.ADUserSSO'">
            <el-form-item :label="$t('ssoRedirect')"  class="padding0Label">
              <el-input type="text" v-model="detail.ssoRedirect"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="6" :offset="6">
          <!-- cas -->
          <el-row  v-if="detail.ssoAuth=='cn.myapps.security.sso.CasUserSSO'">
            <el-form-item :label="$t('localServerName')"  class="padding0Label">
              <el-input type="text" v-model="detail.localServerName" ></el-input>
            </el-form-item>
            <el-form-item :label="$t('casLoginUrl')"  class="padding0Label">
              <el-input type="text" v-model="detail.casLoginUrl"></el-input>
            </el-form-item>
            <el-form-item :label="$t('casUrlPrefix')"  class="padding0Label">
              <el-input type="text" v-model="detail.casUrlPrefix"></el-input>
            </el-form-item>
          </el-row>
          <!-- AD/LDAP -->
          <el-row  v-if="detail.ssoAuth=='cn.myapps.security.sso.ADUserSSO' || detail.ssoAuth=='cn.myapps.security.sso.ADUserSSOJespa'">
            <el-form-item :label="$t('adDomainController')"   class="padding0Label">
              <el-input type="text" v-model="detail.adDomainController" ></el-input>
            </el-form-item>
            <el-form-item :label="$t('adDefaultDomain')"   class="padding0Label">
              <el-input type="text" v-model="detail.adDefaultDomain"></el-input>
            </el-form-item>
            <el-form-item :label="$t('adadminloginno')"   class="padding0Label">
              <el-input type="text" v-model="detail.adadminloginno"></el-input>
            </el-form-item>
            <el-form-item :label="$t('adadminloginnopw')"   class="padding0Label">
              <el-input type="text" v-model="detail.adadminloginnopw"></el-input>
            </el-form-item>
            <el-form-item :label="$t('adlogindomain')"   class="padding0Label">
              <el-input type="text" v-model="detail.adlogindomain"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>
      <el-row  v-if="detail.ssoAuth=='cn.myapps.security.sso.ADUserSSOJespa'">
        <el-divider content-position="left" class="el-divider-header el-divider-bottom">支持NTLMv2设置<span>（注意：采用jespa组件实现，非免费）</span></el-divider>
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('adjespausernmae')"  class="padding0Label">
              <el-input type="text" v-model="detail.adjespausernmae" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="6">
            <el-form-item :label="$t('adjespapassword')"  class="padding0Label">
              <el-input type="text" v-model="detail.adjespapassword"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
        <el-row  v-if="detail.ssoAuth=='cn.myapps.security.sso.ADUserSSO' || detail.ssoAuth=='cn.myapps.security.sso.ADUserSSOJespa'">
          <el-divider content-position="left" class="el-divider-header el-divider-bottom">用户同步设置</el-divider>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('ssoDefaultEmail')"  class="padding0Label">
                <el-input type="text" v-model="detail.ssoDefaultEmail" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="6">
              <el-form-item :label="$t('ssoDefaultPassword')"  class="padding0Label">
                <el-input type="text" v-model="detail.ssoDefaultPassword"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
    </el-form>
    <el-form v-if="detail.authType=='ssl_pkcs12'">
    </el-form>
    <p class="el-divider-header smallHeader">{{$t('setting_after_auth')}}</p>
    <el-form label-position="top"  size="small" class="demo-form-inline"> 
      <el-row>
        <el-col  :span="6">
          <el-form-item :label="$t('ssoSaveType')"  class="padding0Label">
            <el-select v-model="detail.ssoSaveType" :placeholder="$t('placeholder_select')">
              <el-option :label="$t('none')" value="none"></el-option>
              <el-option label="cookie" value="cookie"></el-option>
              <el-option label="session" value="session"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col  :span="6" :offset="6">
          <el-form-item :label="$t('ssoDataEncryption')"  class="padding0Label">
            <el-select v-model="detail.ssoDataEncryption" :placeholder="$t('placeholder_select')">
              <el-option :label="$t('none')" value="none"></el-option>
              <el-option label="base64" value="base64"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('ssoKeyLoginAccount')" prop="loginno"  class="padding0Label">
            <el-input type="text" v-model="detail.ssoKeyLoginAccount"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item :label="$t('ssoKeyDomain')" prop="loginno"  class="padding0Label">
            <el-input type="text" v-model="detail.ssoKeyDomain"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('ssoKeyEmail')" prop="loginno"  class="padding0Label">
            <el-input type="text" v-model="detail.ssoKeyEmail"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <fileUpload :visible.sync="fileUploadVisible" v-if="fileUploadVisible" :nowOption="nowOption" :selectOption="selectOption" @checkUpload="onCheckUpload"/>

  </el-main>
</template>

<script>

import fileUpload from "@/components/fileUpload.vue";

export default {
  data(){
    return {
      authType:"",
      checkldap: '',
      ssoAuthOption:[{
          value: 'cn.myapps.security.sso.CookieUserSSO',
          label: 'cookie'
        }, {
          value: 'cn.myapps.security.sso.CasUserSSO',
          label: 'Cas 服务器'
        }, {
          value: 'cn.myapps.security.sso.ADUserSSO',
          label: 'AD/LDAP'
        }, {
          value: 'cn.myapps.security.sso.ADUserSSOJespa',
          label: 'AD/LDAP（支持NTLMv2协议）'
      }],
      fileUploadVisible:false,
      nowOption:'iconUpload',
      selectOption:'bgImg',
      haveImg:'noLogo',
      loginLogo: 'noLogo',
      imgType: ""
    }
  },
  components:{
    fileUpload,  
  },
  props:["detail","height"],
  watch:{
    detail(newVal){
      this.detail=newVal;
      this.authType=this.detail.authType;
      this.checkldap=this.detail.ssoAuth;
      this.changeAuth()
      if(this.detail.loginbackground!=''){
        this.haveImg='adminLogo'
      }
      if(this.detail.loginLogo!=''){
        this.haveImg='adminLogo'
      }
    }
  },
  methods: {
    //上传背景图
    uploadBgImg(type){
      this.fileUploadVisible=true;
      this.imgType = type;
    },
    cleanBgImg(){
      this.detail.loginbackground='';
    },
    onCheckUpload(file){
      if(this.imgType=="bgcImg"){
        this.detail.loginbackground=this.$api.getLogoUrl(file[0].filePath);
      }else if(this.imgType=="logoImg"){
        this.detail.loginLogo=this.$api.getLogoUrl(file[0].filePath);
      }
      
    },
    changeAuth(){
      if(this.detail.authType == 'sso' && this.checkldap == 'cn.myapps.security.sso.ADUserSSO' || this.checkldap=='cn.myapps.security.sso.ADUserSSOJespa'){
        this.$emit('changeLdap',true );
      }else{
        this.$emit('changeLdap',false );
      }
      this.detail.ssoAuth = this.checkldap
    },
  },
  created(){
    console.log(this.detail)
  }
};
</script>
<style lang="scss" scoped>

</style>